import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Main container for all financial metrics, displays items in a vertical stack
export const DailyFinancialMetricsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  color: theme.colors.gray,
  width: '100%',
}));

// Container for each metric category (net sales, labor costs) with icon and values
export const CategoryContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

// Container for the metric values, displays current and projected values in a column
export const CategoryItemsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));
